import { pushEvent } from 'src/client/data-layer';

export const trackMembershipReadMoreClicked = (
  name: string,
  externalUrl: string,
  productId: number
) => {
  pushEvent('membershipReadMoreClicked', {
    name,
    externalUrl,
    productId,
  });
};
